import { render, staticRenderFns } from "./ArchiveWrapper.vue?vue&type=template&id=4d27d48c&lang=html"
import script from "./ArchiveWrapper.vue?vue&type=script&lang=js"
export * from "./ArchiveWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../modules/tukes/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports